<template>
    <div class="ss-live-page">
        <banner-video :vm="weclassroomBanner"></banner-video>
        <div class="omo-container">
            <section-title :main="omoData.main" :sub="omoData.sub"></section-title>
            <img :src="omoData.image1" alt="">
            <img :src="omoData.image2" alt="">
        </div>

        <div class="scene-container">
            <section-title :main="sceneData.main" :sub="sceneData.sub"></section-title>
            <ul class="scene-list">
                <li v-for="item in sceneData.list" :key="item.title">
                    <img :src="item.bg" alt="">
                    <p>{{ item.title }}</p>
                    <p>{{ item.content }}</p>
                </li>
            </ul>
        </div>

        <div class="customer-container">
            <section-title :main="customerData.main" :sub="customerData.sub"></section-title>
            <ul class="customer-list">
                <!-- <li>
                    <p><img :src="require('@/assets/coursetype/zhiboyun/custom-1.png')" alt=""></p>
                    <p>分布31个省</p>
                    <p>348+地级市</p>
                </li> -->
                <li v-for="item in customerData.list" :key="item.title">
                    <p><img :src="item.image" alt=""></p>
                    <p>{{ item.title }}<br/>{{ item.title1 }}</p>
                    <p v-if="item.content">{{ item.content }}</p>
                </li>
            </ul>
        </div>

        <div class="tese-container">
            <section-title :main="teseData.main" :sub="teseData.sub"></section-title>
            <ul class="tese-list">
                <li v-for="item in teseData.list" :key="item.title">
                    <div class="left">
                        <img :src="item.icon" alt="">
                    </div>
                    <div class="right">
                        <p>{{ item.title }}</p>
                        <p>{{ item.content }}</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import bannerVideo from './components/banner-video'
import { weclassroomBanner } from '@/const'
export default {
    data () {
        return {
            weclassroomBanner: weclassroomBanner,
            omoData: {
                main: 'OMO一站式解决方案',
                sub: '',
                image1: require('@/assets/coursetype/zhiboyun/omo-1.png'),
                image2: require('@/assets/coursetype/zhiboyun/omo-2.png')
            },
            sceneData: {
                main: '多场景全平台线上教学',
                sub: '',
                list: [
                    {
                        bg: require('@/assets/coursetype/zhiboyun/scene-1.png'),
                        title: '互动小班',
                        content: '真实还原线下教学场景'
                    },
                    {
                        bg: require('@/assets/coursetype/zhiboyun/scene-2.png'),
                        title: '万人大班',
                        content: ' 多种互动方式，万人在线，实时留言，畅快沟通'
                    },
                    {
                        bg: require('@/assets/coursetype/zhiboyun/scene-3.png'),
                        title: '1V1量身定制',
                        content: '量身定制，个性辅导，让教学更有针对性'
                    },
                    {
                        bg: require('@/assets/coursetype/zhiboyun/scene-4.png'),
                        title: '全平台支持',
                        content: '支持win、mac、ios、安卓、网页、微信小程序等终端'
                    }
                ]
            },
            customerData: {
                main: '直播云服务的客户',
                sub: '',
                list: Object.freeze([
                    {
                        image: require('@/assets/coursetype/zhiboyun/custom-1.png'),
                        title: '分布31个省',
                        title1: '348+地级市'
                    },
                    {
                        image: require('@/assets/coursetype/zhiboyun/custom-2.png'),
                        title: '100万+',
                        content: '学生'
                    },
                    {
                        image: require('@/assets/coursetype/zhiboyun/custom-3.png'),
                        title: '27万+',
                        content: '教师'
                    },
                    {
                        image: require('@/assets/coursetype/zhiboyun/custom-4.png'),
                        title: '41900+',
                        content: '机构'
                    }
                ])
            },
            teseData: {
                main: '直播云产品特色',
                sub: '',
                list: [
                    {
                        icon: require('@/assets/coursetype/zhiboyun/tese-1.png'),
                        title: '稳定易用上手快',
                        content: '万人同时直播，流畅沟通不卡顿；海外加速遍布全球，超200节点；操作简单，无需培训'
                    },
                    {
                        icon: require('@/assets/coursetype/zhiboyun/tese-2.png'),
                        title: '构建真实教学场景',
                        content: '班级场：还原线下卡糖氛围；强互动：丰富的互动和激励；强控场：关注每一个学生'
                    },
                    {
                        icon: require('@/assets/coursetype/zhiboyun/tese-3.png'),
                        title: '在线教学更专业',
                        content: '全面支持交互式课件；课中练习，边讲边练；与海量教学资源打通，学科工具随时用'
                    },
                    {
                        icon: require('@/assets/coursetype/zhiboyun/tese-4.png'),
                        title: '学习行为数据化',
                        content: '练习巩固线上发布、灵活作答、自动批改；学情报告，效果可视化'
                    },
                ]
            }
        }
    },
    components: { bannerVideo}
}
</script>

<style lang="scss" scoped>
    .omo-container {
        .section-title-box {
            padding-bottom: 0;
        }
        img {
            width: 335px;
        }
    }
    .scene-list {
        li {
            img {
                width: 369px;
            }
            p:nth-of-type(1) {
                font-size: 16px;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #5280FB;
                line-height: 18px;
            }
            p:nth-of-type(2) {
                padding-top: 12px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #8E9DAE;
                line-height: 27px;
            }
        }
    }

    .customer-list {
        padding: 0 20px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;
        li {
            margin-top: 10px;
            width: 163px;
            height: 160px;
            background-color: #F7F8FA;
            img {
                width: 36px;
            }
            p:nth-of-type(1) {
                padding: 26px 0 20px;
            }
            p:nth-of-type(2) {
                font-size: 18px;
                font-weight: bold;
                color: #202428;
                line-height: 24px;
            }
            p:nth-of-type(3) {
                padding-top: 12px;
                font-size: 14px;
                font-weight: 400;
                color: #626D7B;
                line-height: 14px;
            }
        }
        li:nth-of-type(1),
        li:nth-of-type(2) {
            padding-top: 0;
        }
    }

    .tese-list {
        padding: 0 20px;
        li {
            display: flex;
            flex-direction: row;
            padding-top: 40px;
            .right {
                padding-left: 16px;
                p {
                    text-align: left;
                }
                p:nth-of-type(1) {
                    font-size: 16px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #202428;
                    line-height: 16px;
                }
                p:nth-of-type(2) {
                    padding-top: 8px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #8E9DAE;
                    line-height: 21px;
                }
            }
        }
        li:nth-of-type(1) {
            padding-top: 0;
        }
    }
</style>
